import { useScreenSize } from '@/hooks/useScreenSize';
import { useCallback } from 'react';

export const useCalculateIconSize = () => {
    const { scaleWidthPixel, scaleHeightPixel, scaleRatioWidth, scaleRatioHeight } = useScreenSize();

    const calculateIconSize = useCallback(
        (iconSize: { width: number; height: number }) => {
            return {
                width: scaleWidthPixel(iconSize.width),
                height: scaleHeightPixel(iconSize.height),
            };
        },
        [scaleHeightPixel, scaleWidthPixel]
    );

    const calculateUniformIconSize = useCallback(
        (iconSize: { width: number; height: number }) => {
            const uniformScale = Math.min(scaleRatioWidth, scaleRatioHeight);
            return {
                width: Math.round(iconSize.width * uniformScale),
                height: Math.round(iconSize.height * uniformScale),
            };
        },
        [scaleRatioWidth, scaleRatioHeight]
    );

    return { calculateIconSize, calculateUniformIconSize };
};
